import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';

import { HierarchyItem } from '../../../graphql/queries/hierarchy-item';
import FullScreenLoader from '../../../components/global/FullScreenLoader';
import ErrorView from '../../../components/global/ErrorView';
import { isAlbumFolderOwner, isAlbumOwner } from '../../../util/account';
import { isAlbum } from '../../../util/album';
import { getBasenameFromEntity } from '../../../util/role-definitions';
import ERROR_MESSAGES from '../../../constants/error-messages';
import { MeQuery } from '../../../apps/admin/graphql/queries/account';

const propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  entity: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
};

const HierarchyItemEventView = ({ history, user, entity, loading }) => {
  const [error, setError] = useState('');

  const onAccessHierarchyItem = () => {
    const basename = getBasenameFromEntity(entity);
    if (isAlbum(entity) && isAlbumOwner(user, entity)) {
      history.replace(`/app/${basename}/albums/${entity.id}`);
      return;
    }

    if (isAlbumFolderOwner(user, entity)) {
      history.replace(`/app/${basename}/folders/${entity.id}`);
      return;
    }

    setError(ERROR_MESSAGES.E010);
  };

  useEffect(() => {
    if (entity && user) {
      onAccessHierarchyItem();
    }
  }, [entity, user]);

  if (error) {
    return (
      <ErrorView
        location={{
          state: {
            error,
          },
        }}
      />
    );
  }

  if (!loading && !entity) {
    return (
      <ErrorView
        location={{
          state: {
            error:
              'It looks like the link provided does not match any of our records.',
          },
        }}
      />
    );
  }

  return <FullScreenLoader />;
};

HierarchyItemEventView.propTypes = propTypes;

const withMeQuery = graphql(MeQuery, {
  props: ({ data: { me } }) => ({
    user: me,
  }),
});

const withHierarchyItem = graphql(HierarchyItem, {
  options: ({ match }) => ({
    variables: {
      id: match.params.hierarchyItemId,
    },
  }),
  props: ({ data: { hierarchyItem, loading } }) => ({
    loading,
    entity: hierarchyItem?.album_folder ?? hierarchyItem?.album,
  }),
});

export default compose(
  withRouter,
  withMeQuery,
  withHierarchyItem,
)(HierarchyItemEventView);
